<template>
  <div class="info-page" v-if="isVisible && currentWayspotData">
    <div class="cross-btn" @click="handleClose">✕<img src="@/assets/images/button_cover.png" alt="" class="cover-img"></div>
    <div class="info-content">
      <div class="title-with-lines" :class="(currentLanguage == 'en') ? 'en' : ''">
        <div class="title-line"></div>
        <h1>{{ currentWayspotData.title }}</h1>
        <div class="title-line"></div>
      </div>
      <div class="title-scientific" v-if="currentWayspotData.scientific && currentWayspotData.scientific.trim()">
        <span class="oblique">{{ currentWayspotData.scientific.split(' ')[0] }} {{
          currentWayspotData.scientific.split(' ')[1] }}</span>
        {{ currentWayspotData.scientific.split(' ').slice(2).join(' ') }}
      </div>
      <div class="title-description" v-if="currentWayspotData.family && currentWayspotData.family.trim()">
        <div class="title" :class="(currentLanguage =='en') ? 'en' : ''" v-html="getFieldLabel('family')"></div>
        <div class="content" :class="(currentLanguage =='en') ? 'en' : ''">{{ currentWayspotData.family }}</div>
      </div>
      <div class="title-description" v-if="currentWayspotData.localName && currentWayspotData.localName.length > 0">
        <div class="title" :class="(currentLanguage =='en') ? 'en' : ''" v-html="getFieldLabel('localName')"></div>
        <div class="content-2">
          <template v-for="(name, index) in currentWayspotData.localName" :key="index">
            <div class="content-item" :class="(currentLanguage =='en') ? 'en' : ''">
              {{ name.name }}
              <template v-if="name.location && name.location.trim()">
                <br />{{ ' (' + name.location + ')' }}
              </template>
            </div>
            <div v-if="index < currentWayspotData.localName.length - 1" class="">、</div>
          </template>
        </div>
      </div>
      <div class="title-description" v-if="currentWayspotData.taiwanWord && currentWayspotData.taiwanWord.trim()">
        <div class="title" :class="(currentLanguage =='en') ? 'en' : ''" v-html="getFieldLabel('taiwanWord')"></div>
        <div class="content" :class="(currentLanguage =='en') ? 'en' : ''">{{ currentWayspotData.taiwanWord }}</div>
      </div>
      <div class="title-description align-items-top" v-if="currentWayspotData.distribution && currentWayspotData.distribution.trim()">
        <div class="title" :class="(currentLanguage =='en') ? 'en' : ''" v-html="getFieldLabel('distribution')"></div>
        <div class="content" :class="(currentLanguage =='en') ? 'en' : ''">{{ currentWayspotData.distribution }}</div>
      </div>
      <div class="title-description align-items-top"
        v-if="currentWayspotData.morphology && currentWayspotData.morphology.trim()">
        <div class="title" :class="(currentLanguage =='en') ? 'en' : ''" v-html="getFieldLabel('morphology')"></div>
        <div class="content" :class="(currentLanguage =='en') ? 'en' : ''">{{ currentWayspotData.morphology }}</div>
      </div>
      <div class="title-description align-items-top"
        v-if="currentWayspotData.description && currentWayspotData.description.trim()">
        <div class="title" :class="(currentLanguage =='en') ? 'en' : ''" v-html="getFieldLabel('description')"></div>
        <div class="content" :class="(currentLanguage =='en') ? 'en' : ''">{{ currentWayspotData.description }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie'

export default {
  name: 'InfoPage',
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    currentWayspotData: {
      type: Object,
      default: null
    }
  },
  emits: ['close'],
  computed: {
    currentLanguage() {
      return Cookies.get('lang') || 'zh'
    }
  },
  methods: {
    handleClose() {
      this.$emit('close')
    },
    
    // 獲取欄位標籤
    getFieldLabel(field) {
      const labels = {
        zh: {
          family: '科別',
          localName: '卑南族語',
          taiwanWord: '臺灣台語',
          distribution: '分佈',
          morphology: '型態',
          description: '說明'
        },
        en: {
          family: 'Family',
          localName: 'Pinuyumayan<br>Languages',
          taiwanWord: 'Taiwanese<br>Taigi',
          distribution: 'Distribution',
          morphology: 'Description',
          description: 'Notes'
        }
      };

      const currentLang = this.currentLanguage;
      return labels[currentLang]?.[field] || labels.zh[field];
    }
  }
}
</script>

<style scoped>
.en{
    letter-spacing: 0px!important;
    font-size: 1rem!important;
}
.info-page {
  position: absolute;
  background-color: rgba(255, 255, 255, 0.9);
  transform: translate(-50%, -50%);
  left: 50%;
  width: 90%;
  top: 56%;
  height: 83vh;
  height: 83svh;
  /* 使用小視窗高度 */
  border-radius: 15px;
  z-index: 1000;
}

.cross-btn {
  position: absolute;
  top: 0px;
  right: 0px;
  font-size: 25px;
  cursor: pointer;
  background-color: rgb(243 141 145);
  color: white;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid rgba(255, 255, 255, 0.6);
  transform: translate(40%, -30%);
}

.info-content {
  width: 90%;
  margin: auto;
  overflow: scroll;
  max-height: 80vh;
  max-height: 80svh;
  /* 使用小視窗高度 */
}

.title-with-lines {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px auto 10px auto;
  gap: 15px;
  width: 90%;
}

.title-with-lines h1 {
  margin: 0;
  font-size: 2.5rem;
  font-weight: 600;
  color: #436ab2;
  white-space: nowrap;
  letter-spacing: 1px;
}
.title-with-lines.en h1 {
  margin: 0;
  font-size: 1.5rem;
  letter-spacing: 0px;
}

.title-line {
  flex: 1;
  height: 2px;
  background: #436ab2;
  position: relative;
}

.title-scientific {
  text-align: center;
  font-size: 0.9rem;
  color: #555;
  margin-bottom: 20px;
  margin: 0px 0 10px 0;
}

.oblique {
  font-style: oblique;
}

.title-description {
  display: flex;
  justify-content: flex-start;
  gap: 10px;
  margin-bottom: 10px;
  font-size: 1.3rem;
  color: #555;
  align-items: center;
}

.align-items-top {
  align-items: flex-start;
}

.title-description .title {
  background: rgba(67, 106, 178, 0.7);
  padding: 5px 15px;
  border-radius: 7px;
  color: white;
  letter-spacing: 2px;
  white-space: nowrap;
}

.title-description .content {
  text-align: left;
}

.title-description .content-2 {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.cover-img {
  position: absolute;
  width: 50px;
  height: 50px;
  top: 0;
  left: 0;
}

/* Tablet 響應式設計 (768px - 1024px) */
@media screen and (min-width: 768px) and (max-width: 1024px) {
  .cross-btn {
    width: 70px;
    height: 70px;
    font-size: 28px;
    transform: translate(30%, -25%);
  }
  .cover-img{
    width: 70px;
    height: 70px;
  }
  .info-page {
    width: 85%;
    top: 50%;
    height: 80vh;
    border-radius: 20px;
  }
  
  .info-content {
    max-height: 75vh;
  }
  
  .title-with-lines h1 {
    font-size: 3rem;
  }
  
  .title-scientific {
    font-size: 1.3rem;
    margin-bottom: 25px;
  }
  
  .title-description {
    font-size: 1.5rem;
    margin-bottom: 15px;
    gap: 15px;
  }
  
  .title-description .title {
    padding: 8px 20px;
    border-radius: 10px;
  }
}

/* Large Tablet 響應式設計 (1025px - 1366px) */
@media screen and (min-width: 1025px) and (max-width: 1366px) {
  .cross-btn {
    width: 70px;
    height: 70px;
    font-size: 32px;
    transform: translate(25%, -20%);
  }
  .cover-img{
    width: 70px;
    height: 70px;
  }
  .title-with-lines{
    margin: 2rem auto 10px auto;
  }
  .info-page {
    width: 80%;
    top: 50%;
    height: 80vh;
    border-radius: 25px;
  }
  
  .info-content {
    max-height: 80vh;
  }
  
  .title-with-lines h1 {
    font-size: 3.5rem;
  }
  
  .title-scientific {
    font-size: 1.5rem;
    margin-bottom: 30px;
  }
  
  .title-description {
    font-size: 1.7rem;
    margin-bottom: 18px;
    gap: 20px;
  }
  
  .title-description .title {
    padding: 10px 25px;
    border-radius: 12px;
  }
}

/* Landscape Tablet 響應式設計 */
@media screen and (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  .info-page {
    width: 80%;
    height: 75vh;
  }
  
  .info-content {
    max-height: 70vh;
  }
  
  .title-with-lines h1 {
    font-size: 2.5rem;
  }
  
  .title-description {
    font-size: 1.3rem;
    margin-bottom: 12px;
  }
}
</style>